// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const PREMIUM_PAGE_COPY = {
	heroTitle: msg({
		message: 'Stand out. Share more. Go further.',
		context: 'premium',
		comment: 'Premium page hero headline shown to users without premium.',
	}),
	heroSubtitle: msg({
		message:
			'Animated profiles, bigger uploads, 4K streaming and many more perks — all while supporting an independent platform.',
		context: 'premium',
		comment: 'Premium page hero description shown to users without premium.',
	}),
	heroActiveTitle: msg({
		message: 'You are a {premiumProductName} member',
		context: 'premium',
		comment: 'Premium page hero headline shown to active premium users.',
	}),
	heroActiveSubtitle: msg({
		message: 'Thanks for your support! Enjoy your perks, manage your plan or gift premium to a friend.',
		context: 'premium',
		comment: 'Premium page hero description shown to active premium users.',
	}),
	subscribe: msg({
		message: 'Subscribe',
		context: 'premium',
		comment: 'Premium page primary call to action button.',
	}),
	gift: msg({
		message: 'Send a gift',
		context: 'premium',
		comment: 'Premium page call to action that opens gift plans.',
	}),
	managePlan: msg({
		message: 'Manage plan',
		context: 'premium',
		comment: 'Premium page call to action that scrolls to the subscription card.',
	}),
	comparePlans: msg({
		message: 'Compare plans',
		context: 'premium',
		comment: 'Premium page link that scrolls to the free vs premium comparison table.',
	}),
	memberPill: msg({
		message: 'Member',
		context: 'premium',
		comment: 'Small pill on the premium profile preview card.',
	}),
	previewHint: msg({
		message: 'Your profile with premium',
		context: 'premium',
		comment: 'Caption above the profile preview card on the premium page.',
	}),
	perksTitle: msg({
		message: 'Everything you get',
		context: 'premium',
		comment: 'Premium page perk showcase section title.',
	}),
	perksSubtitle: msg({
		message: 'Perks that follow you to every community.',
		context: 'premium',
		comment: 'Premium page perk showcase section description.',
	}),
	perkAnimatedTitle: msg({
		message: 'Animated avatar & banner',
		context: 'premium',
		comment: 'Premium perk card title.',
	}),
	perkAnimatedBody: msg({
		message: 'Bring your profile to life with animated avatars and banners.',
		context: 'premium',
		comment: 'Premium perk card description.',
	}),
	perkUploadTitle: msg({
		message: 'Bigger uploads',
		context: 'premium',
		comment: 'Premium perk card title.',
	}),
	perkUploadBody: msg({
		message: 'Share files up to {size} in a single upload.',
		context: 'premium',
		comment: 'Premium perk card description. {size} is a formatted file size such as 500 MB.',
	}),
	perkVideoTitle: msg({
		message: 'HD streaming',
		context: 'premium',
		comment: 'Premium perk card title.',
	}),
	perkVideoBody: msg({
		message: 'Share your screen and camera in up to 4K at 60fps.',
		context: 'premium',
		comment: 'Premium perk card description. Keep 4K and 60fps untranslated.',
	}),
	perkEmojiTitle: msg({
		message: 'Emoji everywhere',
		context: 'premium',
		comment: 'Premium perk card title.',
	}),
	perkEmojiBody: msg({
		message: 'Use custom emojis and stickers from any community, anywhere.',
		context: 'premium',
		comment: 'Premium perk card description.',
	}),
	perkTagTitle: msg({
		message: 'Custom username tag',
		context: 'premium',
		comment: 'Premium perk card title.',
	}),
	perkTagBody: msg({
		message: 'Pick the 4-digit tag that represents you.',
		context: 'premium',
		comment: 'Premium perk card description.',
	}),
	perkProfilesTitle: msg({
		message: 'Per-community profiles',
		context: 'premium',
		comment: 'Premium perk card title.',
	}),
	perkProfilesBody: msg({
		message: 'Use a different avatar, banner and nickname in each community.',
		context: 'premium',
		comment: 'Premium perk card description.',
	}),
	perkBoostTitle: msg({
		message: '2 community boosts',
		context: 'premium',
		comment: 'Premium perk card title. Keep the number 2.',
	}),
	perkBoostBody: msg({
		message: 'Get 2 community boost slots to level up communities you care about.',
		context: 'premium',
		comment: 'Premium perk card description. Keep the number 2.',
	}),
	perkAvatarFrameTitle: msg({
		message: 'Avatar frame',
		context: 'premium',
		comment: 'Premium perk card title for avatar decorations/frames.',
	}),
	perkAvatarFrameBody: msg({
		message: 'Dress up your avatar with exclusive frames and decorations.',
		context: 'premium',
		comment: 'Premium perk card description.',
	}),
	perkNameplateTitle: msg({
		message: 'Community nameplate',
		context: 'premium',
		comment: 'Premium perk card title for member-list nameplates.',
	}),
	perkNameplateBody: msg({
		message: 'Stand out in member lists with a premium community nameplate.',
		context: 'premium',
		comment: 'Premium perk card description.',
	}),
	perkBadgeTitle: msg({
		message: 'Premium icon',
		context: 'premium',
		comment: 'Premium perk card title.',
	}),
	perkBadgeBody: msg({
		message: 'Show your support with an exclusive premium icon on your profile.',
		context: 'premium',
		comment: 'Premium perk card description.',
	}),
	perkEarlyTitle: msg({
		message: 'Early access',
		context: 'premium',
		comment: 'Premium perk card title.',
	}),
	perkEarlyBody: msg({
		message: 'Try new features before everyone else.',
		context: 'premium',
		comment: 'Premium perk card description.',
	}),
	plansTitle: msg({
		message: 'Choose your plan',
		context: 'premium',
		comment: 'Premium page pricing section title.',
	}),
	plansSubtitle: msg({
		message: 'Cancel anytime. Your perks start right after checkout.',
		context: 'premium',
		comment: 'Premium page pricing section description for self purchases.',
	}),
	giftPlansTitle: msg({
		message: 'Gift {premiumProductName}',
		context: 'premium',
		comment: 'Premium page gift section title.',
	}),
	giftPlansSubtitle: msg({
		message: 'Anyone can redeem a gift code. Pick a duration and share the joy.',
		context: 'premium',
		comment: 'Premium page gift section description.',
	}),
	mostPopular: msg({
		message: 'Most popular',
		context: 'premium',
		comment: 'Ribbon on the highlighted premium plan card.',
	}),
	allPerksIncluded: msg({
		message: 'All premium perks included',
		context: 'premium',
		comment: 'Bullet on a premium plan card.',
	}),
	billedMonthly: msg({
		message: 'Billed every month',
		context: 'premium',
		comment: 'Bullet on the monthly premium plan card.',
	}),
	billedYearly: msg({
		message: 'Billed once a year',
		context: 'premium',
		comment: 'Bullet on the yearly premium plan card.',
	}),
	cancelAnytime: msg({
		message: 'Cancel anytime',
		context: 'premium',
		comment: 'Bullet on a premium plan card.',
	}),
	oneTimeNoRenewal: msg({
		message: 'One-time payment, no renewal',
		context: 'premium',
		comment: 'Bullet on a premium gift plan card.',
	}),
	deliveredAsCode: msg({
		message: 'Delivered as a redeemable gift code',
		context: 'premium',
		comment: 'Bullet on a premium gift plan card.',
	}),
	subscriptionTitle: msg({
		message: 'Your subscription',
		context: 'premium',
		comment: 'Premium page section title above the subscription management card.',
	}),
	billingTitle: msg({
		message: 'Billing & history',
		context: 'premium',
		comment: 'Premium page section title above purchase history and refunds.',
	}),
	compareSubtitle: msg({
		message: 'See exactly what changes when you upgrade.',
		context: 'premium',
		comment: 'Premium page comparison section description.',
	}),
	bottomTitle: msg({
		message: 'Ready to level up?',
		context: 'premium',
		comment: 'Premium page bottom call to action title.',
	}),
	bottomSubtitle: msg({
		message: 'Join {premiumProductName} today and unlock everything above.',
		context: 'premium',
		comment: 'Premium page bottom call to action description.',
	}),
	bottomGiftTitle: msg({
		message: "Make someone's day",
		context: 'premium',
		comment: 'Premium page bottom call to action title in gift mode.',
	}),
	bottomGiftSubtitle: msg({
		message: 'Send {premiumProductName} to a friend as a gift.',
		context: 'premium',
		comment: 'Premium page bottom call to action description in gift mode.',
	}),
	purchaseMode: msg({
		message: 'Purchase mode',
		comment: 'Accessible label for switching between self purchase and gift purchase.',
	}),
	forMe: msg({
		message: 'For me',
		comment: 'Purchase mode option for buying a subscription for the current user.',
	}),
	asAGift: msg({
		message: 'As a gift',
		comment: 'Purchase mode option for buying a gift subscription for another user.',
	}),
	monthly: msg({
		message: 'Monthly',
		comment: 'Billing plan title for a monthly recurring subscription.',
	}),
	perMonth: msg({
		message: 'per month',
		comment: 'Billing cadence label for a monthly subscription price.',
	}),
	yearly: msg({
		message: 'Yearly',
		comment: 'Billing plan title for a yearly recurring subscription.',
	}),
	perYear: msg({
		message: 'per year',
		comment: 'Billing cadence label for a yearly subscription price.',
	}),
	save17: msg({
		message: 'Save 17%',
		comment: 'Price badge comparing yearly billing to monthly billing.',
	}),
	upgradeNow: msg({
		message: 'Upgrade now',
		comment: 'Checkout button for starting a paid subscription.',
	}),
	gift1Year: msg({
		message: '1-year gift',
		comment: 'Billing plan title for a one-year gift subscription.',
	}),
	gift1Month: msg({
		message: '1-month gift',
		comment: 'Billing plan title for a one-month gift subscription.',
	}),
};
